var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    stroke: "rgba(245, 245, 245, 1)",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9109 31.3145C76.583 30.6301 79.3374 32.242 79.6837 34.9786C80.7158 43.1343 79.2133 51.4555 75.3148 58.7846C70.6303 67.5914 62.8243 74.3301 53.428 77.6787C44.0317 81.0274 33.7233 80.7444 24.5249 76.8852C16.8699 73.6736 10.4434 68.1781 6.08487 61.2079C4.62242 58.8691 5.73655 55.8785 8.23927 54.7187C10.742 53.5589 13.679 54.6792 15.2374 56.9552C18.4794 61.69 23.0337 65.427 28.3894 67.674C35.2907 70.5695 43.0249 70.7818 50.0747 68.2694C57.1245 65.757 62.9811 60.7011 66.4958 54.0936C69.2233 48.9659 70.3876 43.1908 69.9044 37.4728C69.6722 34.7242 71.2387 31.9989 73.9109 31.3145Z",
    fill: "#33A937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoader);
export default __webpack_public_path__ + "static/media/ico-loader.9c5b178e31046d0664d68dc73e48c5ef.svg";
export { ForwardRef as ReactComponent };